// components/ChatWidgetLoader.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ChatWidgetLoader = () => {
  const location = useLocation();
  

  useEffect(() => {
    const hideWidgetRegex = /^\/lead-view\/[^/]+$/;
    
    const pathname = location.pathname;
    
    // Remove existing widget if it's there
    const existingScript = document.querySelector('script[src*="leadconnectorhq"]');
    if (existingScript) {
      existingScript.remove();
    }

    if (hideWidgetRegex.test(pathname)) {
      console.log("Chat widget hidden on:", pathname);
      return ;
    }

      const script = document.createElement('script');
      script.src = "https://widgets.leadconnectorhq.com/loader.js";
      script.dataset.resourcesUrl = "https://widgets.leadconnectorhq.com/chat-widget/loader.js";
      script.dataset.widgetId = "67f399331cb27e2ef5a644bc";
      script.async = true;
      document.body.appendChild(script);
    
  }, [location]);

  return null;
};

export default ChatWidgetLoader;
